// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-stack[data-v-96dbd2ba]{position:fixed;top:80px;right:20px;z-index:3000;display:flex;flex-direction:column;gap:10px}", ""]);
// Exports
module.exports = exports;
